import type { ChipProps } from '@mui/material'
import type {
  CodigoMotivoRecusa,
  DecisaoItemChecklist,
  StatusArquivoChecklist,
  StatusItemChecklist,
} from '@/types/checklist'

/**
 * Status do item do checklist (AN-PP3 §3.1, §9). Espelha
 * `br.com.originei.common.documento.StatusItemDocumental`. Os `Record` são exaustivos: falta um
 * status e o `tsc` acusa.
 */
export const STATUS_ITEM_CHECKLIST: readonly StatusItemChecklist[] = [
  'FALTANDO',
  'RECEBIDO',
  'QUARENTENA',
  'VALIDADO',
  'RECUSADO',
  'VENCIDO',
  'SUBSTITUIDO',
] as const

/** Rótulos da tela (§9). */
export const ROTULOS_STATUS_ITEM: Record<StatusItemChecklist, string> = {
  FALTANDO: 'Faltando',
  RECEBIDO: 'Recebido',
  QUARENTENA: 'Em verificação',
  VALIDADO: 'Validado',
  RECUSADO: 'Recusado',
  VENCIDO: 'Vencido',
  SUBSTITUIDO: 'Substituído',
}

/** Cor do chip MUI por status. */
export const CORES_STATUS_ITEM: Record<StatusItemChecklist, NonNullable<ChipProps['color']>> = {
  FALTANDO: 'default',
  RECEBIDO: 'info',
  QUARENTENA: 'warning',
  VALIDADO: 'success',
  RECUSADO: 'error',
  VENCIDO: 'error',
  SUBSTITUIDO: 'default',
}

/** Equivalência com o PDF Políticas Vigentes §9 (documentação da API). */
export const CODIGO_PDF_STATUS_ITEM: Record<StatusItemChecklist, string> = {
  FALTANDO: 'MISSING',
  RECEBIDO: 'RECEIVED',
  QUARENTENA: 'QUARANTINED',
  VALIDADO: 'VALIDATED',
  RECUSADO: 'REJECTED',
  VENCIDO: 'EXPIRED',
  SUBSTITUIDO: 'SUPERSEDED',
}

/** Conta como entregue no envio para análise (e em `presente`/percentual). */
export const contaNoEnvio = (status: StatusItemChecklist): boolean =>
  status === 'RECEBIDO' || status === 'VALIDADO'

/** Conta no encaminhamento ao parceiro e entra no pacote. */
export const contaNoEncaminhamento = (status: StatusItemChecklist): boolean => status === 'VALIDADO'

/** O consultor pode trocar o arquivo (dentro da janela RASCUNHO/COM_PENDENCIA). */
export const permiteTrocaPeloConsultor = (status: StatusItemChecklist): boolean =>
  status === 'RECUSADO' || status === 'VENCIDO' || status === 'RECEBIDO'

/**
 * Texto da situação do arquivo que segura o item em QUARENTENA (§3.1: "Em verificação" ou
 * "Falha na leitura — reenvie"). PROCESSADO e INFECTADO não seguram o item.
 */
export const ROTULOS_SITUACAO_ARQUIVO: Record<StatusArquivoChecklist, string> = {
  PENDENTE: 'Em verificação',
  PROCESSANDO: 'Em verificação',
  QUARENTENA: 'Em verificação',
  ERRO: 'Falha na leitura — reenvie',
  PROCESSADO: 'Processado',
  INFECTADO: 'Arquivo bloqueado',
}

/** Códigos da recusa (`decisoes_item_checklist.codigo_motivo`), na ordem do diálogo. */
export const CODIGOS_MOTIVO_RECUSA: readonly CodigoMotivoRecusa[] = [
  'ILEGIVEL',
  'INCOMPLETO',
  'DIVERGENTE',
  'VENCIDO',
  'TIPO_ERRADO',
  'OUTRO',
] as const

export const ROTULOS_CODIGO_MOTIVO: Record<CodigoMotivoRecusa, string> = {
  ILEGIVEL: 'Ilegível',
  INCOMPLETO: 'Incompleto',
  DIVERGENTE: 'Divergente',
  VENCIDO: 'Vencido',
  TIPO_ERRADO: 'Tipo de documento errado',
  OUTRO: 'Outro',
}

export const ROTULOS_DECISAO_ITEM: Record<DecisaoItemChecklist, string> = {
  VALIDAR: 'Validado',
  RECUSAR: 'Recusado',
}
